export default __webpack_public_path__ + "static/OpenresearcLab-cd851b9af9d6cb11040e5da4cb3e2d88.png";